import chatgptLogo from "../../../assets/chatgpt.svg";
import claudeLogo from "../../../assets/claude.svg";
import geminiLogo from "../../../assets/gemini.svg";
import grokLogo from "../../../assets/grok.svg";
import metaLogo from "../../../assets/metaai.svg";

export type AiProvider = {
  id: "chatgpt" | "claude" | "grok" | "meta" | "gemini";
  name: string;
  url: string;
  logo: string;
  promptParam: "q" | "prompt" | null;
};

export const aiProviders: AiProvider[] = [
  { id: "chatgpt", name: "ChatGPT", url: "https://chatgpt.com/", logo: chatgptLogo, promptParam: "q" },
  { id: "claude", name: "Claude", url: "https://claude.ai/new", logo: claudeLogo, promptParam: "q" },
  { id: "grok", name: "Grok", url: "https://grok.com/", logo: grokLogo, promptParam: "q" },
  { id: "meta", name: "Meta AI", url: "https://www.meta.ai/", logo: metaLogo, promptParam: "prompt" },
  { id: "gemini", name: "Gemini", url: "https://gemini.google.com/app", logo: geminiLogo, promptParam: null },
];

// Longer links risk being rejected by the provider or a proxy in front of it.
const maxPrefillUrlLength = 6000;

export function buildProviderLink(provider: AiProvider, prompt: string) {
  const hasNoPrefill = provider.promptParam === null;
  if (hasNoPrefill) return { url: provider.url, prefilled: false };
  const encodedPrompt = encodeURIComponent(prompt);
  const url = `${provider.url}?${provider.promptParam}=${encodedPrompt}`;
  const isTooLong = url.length > maxPrefillUrlLength;
  if (isTooLong) return { url: provider.url, prefilled: false };
  return { url, prefilled: true };
}
